module.exports = __webpack_public_path__ + "img/PR16.1a439d57.png";